var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { Button } from "./button";
import { ContentPortal } from "../layout/contentportal";
import { FlexContainer } from "../grid/flexcontainer";
import { Grid } from "../grid/grid";
import { bind } from "decko";
import { css } from "emotion";
import { getThemeColorVar } from "../helper/color";
import { Checkbox, GridItem } from "../barrel";
const alertBoxOuterClass = css({
    position: "fixed",
    top: "50%",
    left: "50%",
    right: 0,
    zIndex: 10000,
    width: "660px",
    transform: "translate(-50%, -50%)",
    backgroundColor: getThemeColorVar("background", "default"),
    borderRadius: "0px",
    boxShadow: "0px 6px 32px 0px rgba(0, 0, 0, 0.21)",
});
const alertBoxContentClass = css({
    padding: "54px 68px",
});
const alertBoxOverlayClass = css({
    zIndex: 1,
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: "hidden",
    backgroundColor: getThemeColorVar("background", "darker"),
    opacity: 0.2,
});
function alertBoxHeaderClass(danger) {
    return css({
        fontSize: "20px",
        fontWeight: "bold",
        height: "26px",
        lineHeight: "26px",
        color: danger
            ? getThemeColorVar("negative", "default")
            : getThemeColorVar("typo", "default"),
        marginBottom: "24px",
    });
}
export class AlertBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
        };
    }
    render() {
        const { danger, header, children, actions, checkbox } = this.props;
        return (React.createElement(ContentPortal, null,
            React.createElement("div", { className: alertBoxOuterClass },
                React.createElement(Grid, { columns: 1 },
                    React.createElement("div", { className: alertBoxContentClass },
                        React.createElement("div", { className: alertBoxHeaderClass(danger) }, header),
                        React.createElement("div", null, children)),
                    React.createElement(Grid, { columns: 2, columnSpec: "auto 1fr" },
                        checkbox ? (React.createElement(GridItem, { padding: 16, backgroundColor: {
                                color: "background",
                                colorType: "lighter",
                            }, alignSelf: "start" },
                            React.createElement(Checkbox, { label: checkbox.label, onChange: this.onCheckboxChange }))) : (React.createElement("div", null)),
                        React.createElement(FlexContainer, { direction: "row-reverse", padding: [16, 24], gap: 16, backgroundColor: { color: "background", colorType: "lighter" } }, actions.map((action, idx) => (React.createElement(Button, { key: idx, type: action.type || (idx == 0 ? "primary" : "secondary"), icon: action.icon, onClick: () => action.action(checkbox ? this.state.checked : undefined), danger: danger }, action.label))))))),
            React.createElement("div", { className: alertBoxOverlayClass, onClick: this.handleClose })));
    }
    onCheckboxChange(event) {
        const checked = event.target.checked;
        this.setState({ checked: checked });
        this.props.checkbox &&
            this.props.checkbox.action &&
            this.props.checkbox.action(checked);
    }
    handleClose(event) {
        event.stopPropagation();
        event.preventDefault();
        this.props.onClose && this.props.onClose();
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AlertBox.prototype, "onCheckboxChange", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AlertBox.prototype, "handleClose", null);
//# sourceMappingURL=alertbox.js.map